import { infoUser } from '../../utils/auth'

/**
 * Réglages de paiement : ils vivent chez ESPREMIUM (project.json + table configpay), c'est lui qui décide.
 * Le tracker les lit et les modifie par le socket ESPREMIUM ; les projets (PrimeStation…) ne font que les lire chez lui.
 */
const TIMEOUT_MS = 8000

function emit(socket, event, data = {}) {
    return new Promise((resolve, reject) => {
        if (!socket?.connected) return reject(new Error('Pas connecté à ESPREMIUM'))
        const user = infoUser()
        socket.timeout(TIMEOUT_MS).emit(event, { token: user?.expecttoken, nameAdmin: user?.name, ...data }, (err, res) => {
            if (err) return reject(new Error('ESPREMIUM ne répond pas'))
            resolve(res)
        })
    })
}

/** project.json d'ESPREMIUM + les moyens de chaque projet (noms, dans l'ordre). */
export async function readConfig(socket) {
    const config = await emit(socket, 'empire_get_json')
    if (!config) throw new Error("ESPREMIUM refuse l'accès (token admin)")
    return config
}

/** Une valeur de project.json : interrupteur, compte choisi (STRIPE_SELECTED…). */
export async function setValue(socket, field, value) {
    if (!(await emit(socket, 'empire_edit_json', { target: field, value }))) throw new Error('Modification refusée par ESPREMIUM')
}

/** Moyens de paiement d'un projet, dans l'ordre d'affichage (ligne configpay de ce projet). */
export async function setMethods(socket, configName, names) {
    const data = { value: JSON.stringify(names) }
    if (!(await emit(socket, 'empire_update_db', { table: 'configpay', target: { name: configName }, data, refreshUtils: true }))) {
        throw new Error('Modification refusée par ESPREMIUM')
    }
}

/** Paiements des autres plateformes (table platformpaiement) : { total, page, perPage, rows }. */
export async function listPlatformPayments(socket, { platform = '', status = 'pending', q = '', page = 1 } = {}) {
    const data = await emit(socket, 'empire_tracker_list_platform_paiement', { platform, status, q, page })
    if (!data) throw new Error("ESPREMIUM refuse l'accès (token admin)")
    return data
}

/** Action sur une demande : send_info | valid | refuse | cancel → { status, message }. */
export async function platformPaymentAction(socket, id, action) {
    const res = await emit(socket, 'empire_tracker_platform_paiement_action', { id, action })
    if (!res?.status) throw new Error(res?.message || 'Action refusée par ESPREMIUM')
    return res
}

/**
 * Projets qui vendent un abonnement. open : interrupteur dans project.json ; config : ligne configpay de ses moyens ;
 * list : la même liste renvoyée par empire_get_json ; suffix : compte choisi pour les moyens à plusieurs comptes
 * (stripe_link) — "" = STRIPE_SELECTED, commun à Empire et Vitrine ; PrimeStation a le sien.
 */
export const PROJECTS = [
    { id: 'empire', name: 'Empire', hint: 'Site et app Empire', open: 'PAIEMENTACTIVE', config: 'method_choose', list: 'method_pay', suffix: '', shared: 'Vitrine' },
    { id: 'vitrine', name: 'Vitrine', hint: 'Page vitrine', open: 'PAIEMENTVITRINEACTIVE', config: 'method_choose_vitrine', list: 'method_pay_vitrine', suffix: '', shared: 'Empire' },
    { id: 'primestation', name: 'PrimeStation', hint: 'Lu par PrimeStation au démarrage', open: 'PAIEMENTPRIMESTATIONACTIVE', config: 'method_choose_primestation', list: 'method_pay_primestation', suffix: '_PRIMESTATION' },
]

/** Règles de la demande de paiement (empire_ask_paiement), pour tous les projets. */
export const RULES = [
    { field: 'PAIEMENTAUTO', label: 'Paiement automatique', hint: "Coupé : chaque demande attend qu'un admin envoie le lien." },
    { field: 'PAIEMENTACTIVENOAUTO', label: 'Moyens manuels sans attente', hint: 'Virement, Revolut, Wero… : infos de paiement données tout de suite. Coupé : un admin les envoie.' },
    { field: 'ISADMINAVAILABLE', label: 'Admin disponible', hint: 'Indiqué aux users sur les pages de paiement.' },
]

export const DETAILS = { visa: 'Visa', mastercard: 'Mastercard', applepay: 'Apple Pay', googlepay: 'Google Pay', paypal: 'PayPal', crypto: 'Crypto', app: 'Appli', phone: 'Téléphone' }

/** Champ de project.json qui garde le compte choisi d'un moyen à plusieurs comptes (même règle qu'ESPREMIUM). */
export const selectedField = (key, suffix = '') => (key === 'stripe_link' ? 'STRIPE_SELECTED' : `${key.toUpperCase()}_SELECTED`) + suffix
